import { useTranslation } from "react-i18next";
import { MovementHistory } from "../../../interfaces/Stocks/movementsHistory"
import { Box, TextField } from "@mui/material";
import { PrimaryButton } from "../../../theme/buttons";

interface ViewMovementHistoryProps {
  movementHistoryPayload: MovementHistory,
  setOpenDialog: (open: boolean) => void,
}

export const ViewMovementHistory = ({
  movementHistoryPayload,
  setOpenDialog,
}: ViewMovementHistoryProps) => {
  const [t] = useTranslation("global");

  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1, minWidth: 1000 }}>
        <Box sx={{ display: "flex", flexDirection: "row", gap: 1, width: "100%" }}>
          <TextField
            label={t("movementshistory.fields.movement_quantity")}
            value={movementHistoryPayload.movement_quantity}
            variant="filled"
            InputProps={{
              readOnly: true,
            }}
            InputLabelProps={{
              shrink: true,
            }}
            sx={{ width: "100%" }}
            size="small"
          />
          <TextField
            label={t("movementshistory.fields.movement_date")}
            value={movementHistoryPayload.movement_date ? new Date(movementHistoryPayload.movement_date).toLocaleDateString() : ""}
            variant="filled"
            InputProps={{
              readOnly: true,
            }}
            InputLabelProps={{
              shrink: true,
            }}
            sx={{ width: "100%" }}
            size="small"
          />
        </Box>
        <Box sx={{ display: "flex", flexDirection: "row", gap: 1, width: "100%" }}>
          <TextField
            label={t("movementshistory.fields.current_quantity")}
            value={movementHistoryPayload.current_quantity}
            variant="filled"
            InputProps={{
              readOnly: true,
            }}
            InputLabelProps={{
              shrink: true,
            }}
            sx={{ width: "100%" }}
            size="small"
          />
          <TextField
            label={t("items.title-view")}
            value={movementHistoryPayload.item_code + " - " + movementHistoryPayload.item_description}
            variant="filled"
            InputProps={{
              readOnly: true,
            }}
            InputLabelProps={{
              shrink: true,
            }}
            sx={{ width: "100%" }}
            size="small"
          />
        </Box>
        <Box sx={{ display: "flex", flexDirection: "row", gap: 1, width: "100%" }}>
          <TextField
            label={t("warehouses.title-view")}
            value={
              movementHistoryPayload.warehouse_code && movementHistoryPayload.warehouse_description
                ? `${movementHistoryPayload.warehouse_code} - ${movementHistoryPayload.warehouse_description}`
                : movementHistoryPayload.warehouse_code || movementHistoryPayload.warehouse_description || ""
            }
            variant="filled"
            InputProps={{
              readOnly: true,
            }}
            InputLabelProps={{
              shrink: true,
            }}
            sx={{ width: "100%" }}
            size="small"
          />
          <TextField
            label={t("sections.title-view")}
            value={
              movementHistoryPayload.section_name && movementHistoryPayload.section_description
                ? `${movementHistoryPayload.section_name} - ${movementHistoryPayload.section_description}`
                : movementHistoryPayload.section_name || movementHistoryPayload.section_description || ""
            }
            variant="filled"
            InputProps={{
              readOnly: true,
            }}
            InputLabelProps={{
              shrink: true,
            }}
            sx={{ width: "100%" }}
            size="small"
          />
        </Box>
        <Box sx={{ display: "flex", flexDirection: "row", gap: 1, width: "100%" }}>
          <TextField
            label={t("movementshistory.fields.movement_type")}
            value={
              movementHistoryPayload.movement_type_code + "\n" +
              movementHistoryPayload.movement_type_name + "\n" +
              movementHistoryPayload.movement_type_description
            }
            variant="filled"
            InputProps={{
              readOnly: true,
            }}
            InputLabelProps={{
              shrink: true,
              style: { whiteSpace: "pre-line" },
            }}
            sx={{ width: "100%" }}
            size="small"
            multiline
            rows={3}
            minRows={3}
            maxRows={3}
          />
          <TextField
            label={t("movementshistory.fields.comments")}
            value={
              movementHistoryPayload.comments
            }
            variant="filled"
            InputProps={{
              readOnly: true,
            }}
            InputLabelProps={{
              shrink: true,
            }}
            sx={{ width: "100%" }}
            size="small"
            multiline
            rows={3}
            minRows={3}
            maxRows={3}
          />
        </Box>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "row-reverse", gap: 1, width: "100%", marginTop: 1 }}>
        <PrimaryButton variant="outlined" onClick={() => { setOpenDialog(false); }}>{t("generic.buttons.goback")}</PrimaryButton>
      </Box>
    </>
  )
}
